import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasAuthenticatedSession, pageLifecycle } from "./faro";

export function NavigationObserver() {
  const { key } = useLocation();
  const authenticated = useSelector(hasAuthenticatedSession);
  useEffect(() => {
    if (authenticated) {
      pageLifecycle.commit();
    }
  }, [key, authenticated]);
  return null;
}
